import gql from 'graphql-tag'
export const MESSAGE_SUBSCRIPTION = gql`
  subscription Subscription($chatRoomId: ID!) {
    messageAdded(chatRoomId: $chatRoomId) {
      chatRoomId
      createdAt
      id
      attachments
      mentions {
        id
        firstName
        lastName
      }
      message
      sender {
        id
        firstName
        lastName
      }
      status
    }
  }
`

export const MESSAGE_READ_SUBSCRIPTION = gql`
  subscription onMessageRead($chatRoomId: ID!) {
    messageRead(chatRoomId: $chatRoomId) {
      chatRoomId
      userId
      messageIds
      readBy {
        messageId
        users {
          id
          firstName
          lastName
        }
      }
    }
  }
`
